"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./load-reflect-metadata");
const classTransformer_1 = require("./classTransformer");
const class_validator_1 = require("class-validator");
class Resource {
    static hydrate(from, options) {
        const Constructor = this;
        const instance = new Constructor();
        return (0, classTransformer_1.plainToClassFromExist)(instance, from, options);
    }
    static hydrateArray(fromArray, options) {
        const Constructor = this;
        return fromArray.map((from) => (0, classTransformer_1.plainToClassFromExist)(new Constructor(), from, options));
    }
    validateOrReject(validatorOptions) {
        return (0, class_validator_1.validateOrReject)(this, validatorOptions);
    }
}
exports.default = Resource;
